import React from 'react';
import { Link } from 'react-router-dom';
import { PlusIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const stages = ['Identified', 'Qualified', 'Capture', 'Proposal', 'Submitted', 'Awarded'];

const mockOpportunities = [
  { id: 1, title: 'IT Support Services', agency: 'DOD', value: 2500000, stage: 'Proposal', dueDate: '2024-02-15' },
  { id: 2, title: 'Cybersecurity Assessment', agency: 'DHS', value: 1500000, stage: 'Capture', dueDate: '2024-03-01' },
];

const CRM: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Pipeline & CRM</h1>
          <p className="mt-1 text-gray-600">Track your opportunities from discovery to award</p>
        </div>
        <Link to="/opportunities" className="btn-primary flex items-center gap-2">
          <PlusIcon className="h-5 w-5" />
          Add Opportunity
        </Link>
      </div>

      {/* Pipeline Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: 'Total Pipeline', value: '$12.5M' },
          { label: 'Active Opportunities', value: '24' },
          { label: 'Win Rate', value: '35%' },
          { label: 'YTD Revenue', value: '$3.2M' },
        ].map((stat) => (
          <div key={stat.label} className="bg-white p-4 rounded-lg shadow">
            <p className="text-sm text-gray-500">{stat.label}</p>
            <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Pipeline Board */}
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex gap-4 overflow-x-auto pb-4">
          {stages.map((stage) => (
            <div key={stage} className="min-w-[250px] flex-shrink-0">
              <div className="flex items-center justify-between mb-4">
                <h3 className="font-medium text-gray-900">{stage}</h3>
                <span className="bg-gray-100 text-gray-600 text-xs px-2 py-1 rounded-full">
                  {mockOpportunities.filter((o) => o.stage === stage).length}
                </span>
              </div>
              <div className="space-y-3">
                {mockOpportunities
                  .filter((o) => o.stage === stage)
                  .map((opp) => (
                    <div key={opp.id} className="bg-gray-50 p-3 rounded-lg border border-gray-200">
                      <h4 className="text-sm font-medium text-gray-900">{opp.title}</h4>
                      <p className="text-xs text-gray-500">{opp.agency}</p>
                      <p className="text-sm font-semibold text-gray-900 mt-2">
                        ${(opp.value / 1000000).toFixed(1)}M
                      </p>
                      <p className="text-xs text-gray-500">Due: {opp.dueDate}</p>
                    </div>
                  ))}
                {mockOpportunities.filter((o) => o.stage === stage).length === 0 && (
                  <div className="text-center py-8 text-gray-400 text-sm">No opportunities</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CRM;
